import styled from 'styled-components/macro';
import Sidebar from "./sidebar";
import MobileSidebarContainer from "./mobile_sidebar_container";
import {useCommunityStyle} from "../api/communities";

const MobileCommunitySidebar = styled(({className, profile, topics, community, customFeed, onClose}) => {
    const style = useCommunityStyle(community);
    return (
        <div className={className}>
            <MobileSidebarContainer onClose={onClose}>
                <Sidebar sidebar={style?.sidebar} profile={profile} topics={topics} community={community ? community : 'win'} customFeed={customFeed} onClose={onClose} />
            </MobileSidebarContainer>
        </div>
    )
})`
  ${MobileSidebarContainer} {
    background-color: ${({theme}) => theme.color.name === 'dark' ? theme.dark_field : '#e9e9ec'};
    right: 0;
    padding: 12px;
  }

  ${Sidebar} {
    display: initial;
    overflow: scroll;
    height: 100vh;
  }

`;

export default MobileCommunitySidebar;
